import {BLOCKS, MARKS} from '@contentful/rich-text-types';
import {Typography} from 'antd';
import React from 'react';

export default {
    renderMark: {
        [MARKS.BOLD]: text => <Typography.Text strong>{text}</Typography.Text>,
    },
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => <Typography.Paragraph>{children}</Typography.Paragraph>,
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
            return (
                <img
                    src={node.data.target.fixed.src}
                    alt={node.data.target.title}
                />
            )
        },
    },
};
